import { formatStatusRoom, formatTimeUTCToLocal } from '@/utils/format';
import dayjs from 'dayjs';
import { SELLER_ID_NOT_SHOW } from '@/constants/common';
import router from '@/router';
import { EMIT_SOCKET, MESSAGE } from '../mutation-types';

export const state = {
  user: null,
  friends: [],
  messages: [],
  channels: [],
  channelInfo: null,
  totalPagesMessage: 0,
  messageSearch: {},
};

export const mutations = {
  [MESSAGE.SET_MESSAGE](state, data) {
    const listData = [];
    for (let i = data.length - 1; i >= 0; i--) {
      // data[i].createOn = formatTimeUTCToLocal(data[i].createOn);
      data[i].sendText = data.userLoginId === data[i].senderId ? 'my_chat' : 'your_chat';
      data[i].isRead = data.userLoginId === data[i].senderId ? 'd-none' : '';
      if (state.messages.length === 0
        || data[i]._id !== state.messages[0]._id) {
        listData.push(data[i]);
      }
    }
    state.messages = listData.concat(state.messages);
  },
  [MESSAGE.ADD_MESSAGE](state, dataMessage) {
    dataMessage.sendText = dataMessage.userLoginId === dataMessage.senderId ? 'my_chat' : 'your_chat';
    dataMessage.isRead = dataMessage.userLoginId === dataMessage.senderId ? 'd-none' : '';
    state.messages.push(dataMessage);
  },
  [MESSAGE.SET_CHANNEL](state, data) {
    data.statusName = formatStatusRoom(
      data.userLoginId,
      data.userSellerParentId,
      data.status,
      data?.isForwarder
    );
    state.channels.unshift(data);
  },
  [MESSAGE.SET_ALL_CHANNEL](state, data) {
    data.forEach((item) => {
      item.statusName = formatStatusRoom(
        data.userLoginId,
        item.userSellerParentId,
        item.status,
        item?.isForwarder
      );
    });
    state.channels = data;
  },
  [MESSAGE.GET_INFO_CHANNEL](state, data) {
    if (data?.wonBidIdNew && data?.userLoginId === state.channelInfo?.userSellerParentId) {
      router.replace({
        name: 'Message Detail',
        params: {
          won_bid_id: data.wonBidIdNew,
        }
      });
    } else {
      state.channelInfo = data;
    }
  },
  [MESSAGE.UPDATE_CHANNEL](state, data) {
    const room = state.channels.find((item) => item._id === data._id);
    if (room) {
      if (data.userSellerParentId === SELLER_ID_NOT_SHOW
        && data.userLoginId === room.userSellerParentId) {
        const index = state.channels.findIndex((item) => item._id === data._id);
        if (index !== -1) {
          state.channels.splice(index, 1);
        }
      } else {
        data.statusName = formatStatusRoom(
          data.userLoginId,
          data.userSellerParentId,
          data.status,
          data?.isForwarder
        );
        const index = state.channels.findIndex((item) => item._id === data._id);
        if (index !== -1) {
          state.channels.splice(index, 1);
        }
        state.channels.unshift(data);
      }
    }
  },
  [MESSAGE.LOAD_MORE_CHANNEL](state, data) {
    const dataChannel = [];
    data.forEach((item) => {
      item.statusName = formatStatusRoom(
        data.userLoginId,
        item.userSellerParentId,
        item.status,
        item?.isForwarder
      );
      if (item._id !== state.channels[state.channels.length - 1]?._id) {
        dataChannel.push(item);
      }
    });
    state.channels = [...state.channels, ...dataChannel];
  },
  [MESSAGE.RESET_DATA](state) {
    state.channels = [];
    state.channelInfo = null;
    state.messages = [];
  },
  [MESSAGE.TOTAL_PAGE_MESSAGES](state, total) {
    state.totalPagesMessage = total;
  },
  [MESSAGE.RESET_ROOM](state) {
    state.channelInfo = null;
    state.messages = [];
  },
};
export const actions = {
  setMessage({ commit }, data) {
    commit(MESSAGE.SET_MESSAGE, data);
  },
  getMessage(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_GET_MESSAGE, data);
  },
  joinChannel(_, channel) {
    this.$socket.emit(EMIT_SOCKET.EMIT_JOIN_CHANNEL, channel);
  },
  addMessage({ commit }, message) {
    commit(MESSAGE.ADD_MESSAGE, message);
  },
  sendMessage(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_SEND_MESSAGE, data);
  },
  updateMessage(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_UPDATE_MESSAGE, data);
  },
  leaveChannel(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_LEAVE_CHANNEL, data);
  },
  joinMessage(_, userId) {
    this.$socket.emit(EMIT_SOCKET.EMIT_JOIN_MESSAGE, userId);
  },
  createChannel(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_CREATE_CHANNEL, data);
  },
  setChannel({ commit }, channel) {
    commit(MESSAGE.SET_CHANNEL, channel);
  },
  getAllChannel(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_FIND_ALL_CHANNEL, data);
  },
  findChannel(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_FIND_CHANNEL, data);
  },
  setAllChannel({ commit }, data) {
    commit(MESSAGE.SET_ALL_CHANNEL, data);
  },
  getInfoChannel({ commit }, data) {
    commit(MESSAGE.GET_INFO_CHANNEL, data);
  },
  updateStatusChannel(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_UPDATE_STATUS, data);
  },
  updateChannel({ commit }, data) {
    commit(MESSAGE.UPDATE_CHANNEL, data);
  },
  resetData({ commit }) {
    commit(MESSAGE.RESET_DATA);
  },
  resetRoom({ commit }) {
    commit(MESSAGE.RESET_ROOM);
  },
  setTotalPagesMessage({ commit }, total) {
    commit(MESSAGE.TOTAL_PAGE_MESSAGES, total);
  },
  getMessagesFromDate(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_GET_MESSAGE_FROM_DATE, data);
  },
  getChannelsFromDate(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_GET_CHANNELS_FROM_DATE, data);
  },
  likeChannel(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_LIKE_CHANNEL, data);
  },
  getChannelFromMessage(_, data) {
    this.$socket.emit(EMIT_SOCKET.EMIT_SEARCH_CHANNEL, data);
  },
  loadMoreChannel({ commit }, data) {
    commit(MESSAGE.LOAD_MORE_CHANNEL, data);
  }
};
export const getters = {
  messages: state => state.messages,
  allChannels: state => state.channels,
  channelInfo: state => state.channelInfo,
  totalPagesMessage: state => state.totalPagesMessage,
  messageSearch: state => state.messageSearch
};
